import { pipe } from 'ramda'
import {
  setEvent,
  setCategory,
  setReceivedPath,
  dispatchEvent,
  setParamObj,
} from '@creditas-lab/analytics-events'

const setPageViewEventData = (path, params) => ({
  ...setReceivedPath(path),
  ...setParamObj(params),
})

const dispatchPageViewEvent = pipe(
  setPageViewEventData,
  setEvent('creditas.pageview'),
  dispatchEvent,
)

const dispatchFrontendLoginEvent = pipe(
  setCategory('login_application'),
  setEvent('frontend_interaction_event'),
  dispatchEvent,
)

export { dispatchPageViewEvent, dispatchFrontendLoginEvent }
